import actionTypes from './cta.types';
export default {
  updateCtaLoading: state => state.type === actionTypes.UPDATE_CTA_REQUEST,
  updateCtaSuccess: state => state.type === actionTypes.UPDATE_CTA_SUCCESS,
  updateCtaFailed: state => state.type === actionTypes.UPDATE_CTA_FAILED,

  addCtaLoading: state => state.type === actionTypes.ADD_CTA_REQUEST,
  addCtaSuccess: state => state.type === actionTypes.ADD_CTA_SUCCESS,
  addCtaFailed: state => state.type === actionTypes.ADD_CTA_FAILED,

  fetchCtasLoading: state => state.type === actionTypes.FETCH_CTAS_REQUEST,
  fetchCtasSuccess: state => state.type === actionTypes.FETCH_CTAS_SUCCESS,
  fetchCtasFailed: state => state.type === actionTypes.FETCH_CTAS_FAILED,

  deleteCtasLoading: state => state.type === actionTypes.DELETE_CTA_REQUEST,
  deleteCtasSuccess: state => state.type === actionTypes.DELETE_CTA_SUCCESS,
  deleteCtasFailed: state => state.type === actionTypes.DELETE_CTA_FAILED
};
